import { render, staticRenderFns } from "./EventHistoryAutomationProps.vue?vue&type=template&id=f998ad0c"
import script from "./EventHistoryAutomationProps.vue?vue&type=script&lang=js"
export * from "./EventHistoryAutomationProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports